import styled from 'styled-components'

const BtnGroup = styled.div`
  display: flex;
  justify-content: space-between;
`

export default BtnGroup